import { Pill } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

interface PlacementRecentlyAddedPillProps {
  blurred?: boolean;
}

export function PlacementRecentlyAddedPill(props: PlacementRecentlyAddedPillProps) {
  const { blurred = false } = props;

  return (
    <Pill
      iconType="new"
      label={
        <Box component="span" style={{ filter: blurred ? "blur(8px)" : undefined }}>
          New
        </Box>
      }
      variant="filled"
      size="small"
      backgroundColor={(theme) => theme.palette.intent?.neutral.background}
      color={(theme) => theme.palette.intent?.neutral.text}
    />
  );
}
